var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var isServer = typeof window === "undefined";
export var isClient = !isServer;
export var APP_URL = isClient ? location.origin : "";
export var isSafari = isClient
    ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    : false;
export var isFirefox = isClient
    ? /firefox/gi.test(navigator.userAgent)
    : false;
export var isIOS = (function () {
    return isClient
        ? [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod",
        ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        : false;
})();
export var isDev = process.env.NEXT_PUBLIC_APP_ENV !== "production";
export var isLocalServer = isServer && process.env.NEXT_PUBLIC_SERVER_ENV === "local";
export function isProbablyInAppBrowser() {
    var e_1, _a;
    if (isServer)
        return [false, null];
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var inAppBrowsers = [
        "Instagram",
        ["Facebook", "FBAN", "FBAV", "FB_IAB", "FB4A", "FBIOS"],
        "Twitter",
        "LinkedIn",
        "Pinterest",
        "Snapchat",
        "TikTok",
        "Reddit",
    ];
    for (var i = 0; i < inAppBrowsers.length; i++) {
        var agent = inAppBrowsers[i];
        var _b = __read(typeof agent === "string" ? [agent, agent] : agent), name_1 = _b[0], parts = _b.slice(1);
        try {
            for (var parts_1 = (e_1 = void 0, __values(parts)), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                var part = parts_1_1.value;
                if (userAgent.indexOf(part) > -1) {
                    return [true, name_1];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return [false, null];
}
